import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './context/AuthContext.js';
import { getApiBase } from './backendProbe.js';

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    // Prevent browser from showing "unsaved changes" warning
    window.history.replaceState(null, '', window.location.href);
    
    // Extract access token from URL fragment (Microsoft uses fragment mode)
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      console.error('Microsoft OAuth error:', error, errorDescription);
      let errorMessage = errorDescription || error;
      
      // Provide helpful error messages for common issues
      if (error === 'unauthorized_client') {
        errorMessage = 'Microsoft login is not properly configured. Please contact support or use another login method (Google, Apple, or Facebook).';
      } else if (error === 'access_denied') {
        errorMessage = 'You cancelled the Microsoft login. Please try again if you want to continue.';
      }
      
      setIsProcessing(false);
      // Use replace to avoid back button issues
      setTimeout(() => {
        alert(`Microsoft login failed: ${errorMessage}`);
        navigate('/login', { replace: true });
      }, 100);
      return;
    }

    if (accessToken) {
      // Send token to backend
      const base = getApiBase();
      const endpoint = base ? `${base}/auth/microsoft` : '/auth/microsoft';
      axios.post(endpoint, { accessToken })
        .then((response) => {
          login(response.data.token, response.data.user);
          setIsProcessing(false);
          // Use replace to avoid back button issues and prevent warnings
          navigate('/chatbot', { replace: true });
        })
        .catch((err) => {
          console.error('Microsoft login failed', err);
          setIsProcessing(false);
          const msg = err.response?.status === 403 && err.response?.data?.code === 'INVITE_ONLY'
            ? (err.response.data.message || "This app is invite-only. You don't have access.")
            : 'Microsoft login failed. Please try again.';
          setTimeout(() => {
            alert(msg);
            navigate('/login', { replace: true });
          }, 100);
        });
    } else {
      console.error('No Microsoft access token found in callback');
      setIsProcessing(false);
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 100);
    }
  }, [navigate, login]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px'
    }}>
      {isProcessing ? 'Processing Microsoft login...' : 'Redirecting...'}
    </div>
  );
}

